import { View } from 'backbone.marionette';
import template from './index.jst';
import './index.styl';

export class CorePrizes extends View {
	get template() {
		return template;
	}

	async initialize() {
		await this.fetchData();
		this.updateModel().render();
	}

	fetchData() {
		return Promise.all( [
			this.collection.fetch()
		] );
	}

	updateModel() {
		const winners = this.collection
			.getSortedWinners();

		this.model.set( { winners } );

		return this;
	}
}

export default CorePrizes;